import config from '../../config'
import { useCallback, useMemo } from 'react'
import axios from 'axios'
import { useMutation } from '@tanstack/react-query'

import { IUseUpdateMutation, IUpdateFn, ITrainingTypeUpsert, ITrainingType, IGetPutRequest } from '../../interfaces'

const getUpdateTrainingTypeMutationRequest: IGetPutRequest = params => {

  return {
    method: 'put',
    url: `${config.baseUrl}/TrainingTypes/`,
  }
}

const useUpdateTrainingTypeMutation: IUseUpdateMutation<ITrainingType, ITrainingTypeUpsert> = (params, options = {}) => {
  const request = useMemo(() => getUpdateTrainingTypeMutationRequest(params), [params])

  const updateTraining: IUpdateFn<ITrainingTypeUpsert, ITrainingType> = useCallback(
    async data => {
      return axios({ ...request, url: request.url + data.id, data }).then(res => res.data)
    },
    [request],
  )

  const response = useMutation<ITrainingType, Error, any>({
    mutationFn: updateTraining,
    ...options,
  })

  return response
}

export default useUpdateTrainingTypeMutation
